require('./clockTimeTransformer');

angular.module('app.shared.dataTransformers.clipTransformer', [
  'app.shared.dataTransformers.clockTimeTransformer'
])
  .factory('app.shared.dataTransformers.clipTransformer',
    [
      'app.shared.dataTransformers.clockTimeTransformer',
      '$filter',
      function (clockTimeTransformer, $filter) {
        "use strict";

        let service = {
          transformToUi: (clip) => {
            if (clip) {
              if (clip.iclipcategoryid_fk) {
                clip.iclipcategoryid_fk = parseInt(clip.iclipcategoryid_fk);
              }

              let clipStart = service.getStartTime(clip);
              clip.startClockTime = service.secondsToClockTime(clipStart);

              let clipEnd = clipStart + parseInt(clip.strsourceduration);
              clip.endClockTime = service.secondsToClockTime(clipEnd);

              let time = parseInt(clip.strsourceduration);
              clip.clockTime = service.secondsToClockTime(time);

              if (typeof clip.strgoalassist !== 'undefined') {
                clip.goalAssist = JSON.parse(clip.strgoalassist);
              }

              if (clip.hasOwnProperty('game_clocktime')) {
                clip.gameClockTimeUi = {
                  minute: null,
                  second: null
                };

                if (clip.game_clocktime) {
                  let time = clip.game_clocktime.split(":");
                  clip.gameClockTimeUi.minute = parseInt(time[0]);
                  clip.gameClockTimeUi.second = parseInt(time[1]);
                }
              }
            }

            return clip;
          },
          transformToApi: (clip, preferDbFields = false) => {
            if (!preferDbFields && clip.clockTime) {
              clip.itimeinseconds = service.clockTimeToSeconds(clip.clockTime);
              delete clip.clockTime;
            }

            if (!preferDbFields && clip.gameClockTimeUi) {
              if (clip.gameClockTimeUi.minute || clip.gameClockTimeUi.second) {
                if (!clip.gameClockTimeUi.minute) {
                  clip.gameClockTimeUi.minute = '00'
                }
                if (!clip.gameClockTimeUi.second) {
                  clip.gameClockTimeUi.second = '00'
                }
                clip.game_clocktime = clip.gameClockTimeUi.minute + ':' + clip.gameClockTimeUi.second;
              }

              delete clip.gameClockTimeUi;
            }

            if (!preferDbFields && clip.startClockTime) {
              clip.iclipstartutc = service.clockTimeToSeconds(clip.startClockTime) + parseInt(clip.game.istarttime);
              delete clip.startClockTime;
            }

            if (!preferDbFields && clip.endClockTime) {
              let endTime = service.clockTimeToSeconds(clip.endClockTime) + parseInt(clip.game.istarttime);
              clip.strsourceduration = endTime - clip.iclipstartutc;
              delete clip.endClockTime;
            }

            if (!preferDbFields && Number.isInteger(clip.iispublic)) {
              clip.iispublic = clip.iispublic > 0;
            }

            if (typeof clip.goalAssist !== 'undefined') {
              clip.strgoalassist = JSON.stringify(clip.goalAssist);
            }

            delete clip.iclipid;
            delete clip.game;
            delete clip.likes;
            delete clip.i_like;
            delete clip.watch_count;
            delete clip.can_syndicate;
            delete clip.goalAssist;
            delete clip.clip_category;
            delete clip.type;
            delete clip.sort_date;
            delete clip.lineup;
            delete clip.is_starred;
            delete clip.category;
            delete clip.subcategory;
            delete clip.subcategory_strength;
            delete clip.lines;

            return clip;
          },

          transformToHotKey: (hotkeys) => {
            if (Array.isArray(hotkeys)) {
              let keys = hotkeys;

              let quick_clip_override = $filter('filter')(keys, { strclipcategory: 'Quick Clip' });

              if (!quick_clip_override.length) {
                let quickClipHotKey = {
                  "iclipcategoryid": null,
                  "strascii": 32,
                  "strclipcategory": "Quick Clip",
                  "strkeyboardshortcut": "spacebar",
                  "ikeycode": 32,
                  "istartclip": 10,
                  "iduration": 20
                };
                keys.push(quickClipHotKey);
              }

              hotkeys = keys;
            }

            return hotkeys;
          },

          getStartTime: (clip, game) => {
            let start = null;

            if (clip.game) {
              game = clip.game
            }

            if (clip && game) {
              if (clip.iclipstartutc) {
                let clipStart = parseFloat(clip.iclipstartutc);
                let offset = parseFloat(game.istarttime);

                if (isNaN(clipStart)) clipStart = 0;
                if (isNaN(offset)) offset = 0;

                if (parseInt(clip.iclipcreationgamestatus) === 1) {
                  if (parseInt(game.blivegameflag) === 2) {
                    offset = 0;
                  } else {
                    offset = parseInt(game.istarttime) - offset;
                  }
                } else {
                  offset = parseInt(game.istarttime);
                }

                start = clipStart - offset;
              } else {
                if (clip.strsourcestartutc) {
                  let source_start = parseFloat(clip.strsourcestart);

                  start = isNaN(source_start) ? 0 : source_start;
                } else {
                  let source_start = parseFloat(clip.strsourcestart);

                  if (isNaN(source_start)) source_start = 0;

                  start = source_start;
                }
              }
            }

            return Math.floor(start);
          }
        };

        angular.merge(service, clockTimeTransformer);

        return service;
      }
    ]
  );


// WEBPACK FOOTER //
// ./app.v2/components/shared/dataTransformers/clipTransformer.js